export var splitFiltersFromQueryParams = function(queryParams) {
    var _queryParams_get;
    return queryParams === null || queryParams === void 0 ? void 0 : (_queryParams_get = queryParams.get("filters")) === null || _queryParams_get === void 0 ? void 0 : _queryParams_get.split(/,(?!\s)/);
};
export var splitFiltersFromQueryParamString = function(queryParamsString) {
    // Only split by comma if there is no space after the comma to patch issues with commas in taxonomy filter keys
    return queryParamsString === null || queryParamsString === void 0 ? void 0 : queryParamsString.split(/,(?!\s)/);
};
